/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchGroupsRequest
 */
export interface SearchGroupsRequest {
    /**
     * The search pattern to filter groups by name
     * @type {string}
     * @memberof SearchGroupsRequest
     */
    pattern?: string;
}

/**
 * Check if a given object implements the SearchGroupsRequest interface.
 */
export function instanceOfSearchGroupsRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SearchGroupsRequestFromJSON(json: any): SearchGroupsRequest {
    return SearchGroupsRequestFromJSONTyped(json, false);
}

export function SearchGroupsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchGroupsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pattern': !exists(json, 'pattern') ? undefined : json['pattern'],
    };
}

export function SearchGroupsRequestToJSON(value?: SearchGroupsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pattern': value.pattern,
    };
}

